import React, { useState } from "react";
import KeyIcon from "@mui/icons-material/Key";
import { useDispatch, useSelector } from "react-redux";
import request from "../../Helpers/API";
import Swal from "sweetalert2";
import { types } from "../../Helpers/Types";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

export const UpdatePasswordScreen = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const [val_password, setValPassword] = useState("");
  const [val_confirm_password, setValConfimPassword] = useState("");
  const [state, setState] = useState({
    letra_minuscula: false,
    letra_mayuscula: false,
    numero: false,
    caracter_Especial: false,
    minimo: false,
    maximo: false,
    disabled: true,
    contraseña_coincide: false,
  });
  const ActualizaPassword = ({ value }) => {
    setValPassword(value);
    const uppercaseRegex = /[A-Z]/; // Verificar letras mayúsculas
    const lowercaseRegex = /[a-z]/; // Verificar letras minúsculas
    const numberRegex = /[0-9]/; // Verificar números
    const specialCharsRegex = /[!@#$%^&*(),.?":{}|<>]/;
    var letra_minuscula = lowercaseRegex.test(value);
    var letra_mayuscula = uppercaseRegex.test(value);
    var numero = numberRegex.test(value);
    var caracter_Especial = specialCharsRegex.test(value);
    var minimo = value.length >= 8 ? true : false;
    var maximo = value.length <= 30 ? true : false;
    var disabled = true;
    var contraseña_coincide =
      value === val_confirm_password && value.length > 0 ? true : false;

    if (
      letra_mayuscula === true &&
      letra_minuscula === true &&
      numero === true &&
      caracter_Especial === true &&
      minimo === true &&
      maximo === true &&
      contraseña_coincide === true
    ) {
      disabled = false;
    }

    setState({
      letra_mayuscula,
      letra_minuscula,
      numero,
      caracter_Especial,
      minimo,
      maximo,
      disabled,
      contraseña_coincide,
    });
  };
  const ConfirmaPAssword = ({ value }) => {
    setValConfimPassword(value);
    var contraseña_coincide = false;
    var disabled = true;
    if (val_password === value && value.length > 0) {
      contraseña_coincide = true;
    }
    if (
      state.letra_mayuscula === true &&
      state.letra_minuscula === true &&
      state.numero === true &&
      state.caracter_Especial === true &&
      state.minimo === true &&
      state.maximo === true &&
      contraseña_coincide === true
    ) {
      disabled = false;
    }
    setState({
      ...state,
      contraseña_coincide,
      disabled,
    });
  };
  const onActualizarContraseña = () => {
    if (state.disabled) return;
    const post = {
      usuario: Number(location.state.usuario),
      password: val_password,
      confirmpassword: val_confirm_password,
    };
    setLoading(true);
    request
      .postToken("UpdatePassword", post, location.state.token)
      .then(async (result) => {
        setLoading(false);
        await Swal.fire(
          "Actualización de contraseña",
          JSON.stringify(result.mensaje),
          "success"
        );
        localStorage.setItem("HumayaDigital-Token", location.state.token);
        window.location.reload();
        // dispatch({
        //   type: types.sesion,
        //   payload: {
        //     menus: location.state.menus,
        //     modulos: location.state.modulos,
        //     autenticado: true,
        //   },
        // });
      })
      .catch((error) => {
        setLoading(false);
        Swal.fire(
          "Actualización de contraseña",
          JSON.stringify(error),
          "error"
        );
      });
  };

  return (
    <>
      <div className="form-login-controls">
        <div className="up-titulo">Actualizar Contraseña</div>
        <div className="up-container-input">
          <div className="up-label">Contraseña</div>
          <input
            type="password"
            value={state.val_password}
            onChange={({ target }) => ActualizaPassword(target)}
          />
        </div>
        <div className="up-container-input">
          <div className="up-label">Confirmar Contraseña</div>
          <input
            type="password"
            value={state.val_confirm_password}
            onChange={({ target }) => ConfirmaPAssword(target)}
          />
        </div>
        <button
          onClick={() => onActualizarContraseña()}
          className={`${
            state.disabled === false
              ? "up-button-actualizar"
              : "up-button-actualizar-disabled"
          }`}
        >
          Actualizar
        </button>
        <div id="check-list-password-login" className="scroll-4">
          <div
            className={`check-options ${
              state.letra_minuscula === false ? "red" : "green"
            }`}
          >
            <KeyIcon />
            Se requiere carácter en minúscula
          </div>
          <div
            className={`check-options ${
              state.letra_mayuscula === false ? "red" : "green"
            }`}
          >
            <KeyIcon />
            Se requiere carácter en mayúscula
          </div>
          <div
            className={`check-options ${
              state.numero === false ? "red" : "green"
            }`}
          >
            <KeyIcon />
            Se requiere un carácter numérico
          </div>
          <div
            className={`check-options ${
              state.caracter_Especial === false ? "red" : "green"
            }`}
          >
            <KeyIcon />
            {`Se requiere un carácter no alfanumérico. (^ $ * . [ ] { } ( ) ? " ! @ # % & , > <  : ; | _ )`}
          </div>
          <div
            className={`check-options ${
              state.minimo === false ? "red" : "green"
            }`}
          >
            <KeyIcon />
            Longitud mínima de la contraseña 8 caracteres
          </div>
          {/* <div
          className={`check-options ${
            state.maximo === false ? "red" : "green"
          }`}
        >
          <KeyIcon />
          Longitud máxima de las contraseñas 30 caracteres
        </div> */}
          <div
            className={`check-options ${
              state.contraseña_coincide === false ? "red" : "green"
            }`}
          >
            <KeyIcon />
            Contraseñas coinciden
          </div>
        </div>
      </div>
      {loading && (
        <div className="spinner">
          <div className="lds-facebook">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}
    </>
  );
};
